export default __webpack_public_path__ + "media/color/ncash-c066b7e3.svg";